export default "__VITE_ASSET__DCldgV36__"